import React from 'react';
import { Link } from 'react-router-dom';

const Residential = () => {
  return (
    <div className="min-h-screen bg-white">
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-white via-cyan-50 to-white overflow-hidden">
        <div className="absolute inset-0 opacity-30">
          <div className="absolute top-20 right-20 w-72 h-72 bg-cyan-400/30 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 left-20 w-72 h-72 bg-navy-900/20 rounded-full blur-3xl"></div>
        </div>

        <div className="relative container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl">
            <div className="inline-block bg-cyan-400/10 border border-cyan-400/30 rounded-full px-6 py-2 mb-6">
              <span className="text-sm font-bold text-navy-900 tracking-wide">HOME CLEANING EXPERTS</span>
            </div>
            <h1 className="text-5xl md:text-7xl font-black text-navy-900 leading-none mb-6">
              Residential Cleaning<br />
              <span className="text-cyan-500">Services</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 mb-8 leading-relaxed">
              Professional home cleaning that gives you more time for what matters most.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link to="/get-quote" className="px-8 py-4 bg-navy-900 text-white font-bold rounded-xl hover:bg-navy-800 shadow-lg">
                BOOK CLEANING
              </Link>
              <Link to="/get-quote" className="px-8 py-4 bg-white border-2 border-navy-900 text-navy-900 font-bold rounded-xl hover:bg-gray-50 shadow-lg">
                VIEW PRICING
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                title: 'One-Time Deep Clean',
                description: 'Comprehensive deep cleaning for special occasions or seasonal refresh',
                features: ['Complete home sanitization', 'All rooms included', 'Move-in/move-out ready', 'Special event preparation'],
                icon: '✨',
              },
              {
                title: 'Regular Cleaning',
                description: 'Weekly, bi-weekly, or monthly cleaning to maintain a spotless home',
                features: ['Flexible scheduling', 'Consistent quality', 'Same cleaner each visit', 'Priority booking'],
                icon: '🗓️',
              },
              {
                title: 'Custom Packages',
                description: 'Tailored cleaning plans designed around your specific needs',
                features: ['Personalized checklist', 'Add-on services', 'Focus on priority areas', 'Budget-friendly options'],
                icon: '🎯',
              },
            ].map((service, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border-2 border-gray-200 hover:border-cyan-400 shadow-lg"
              >
                <div className="text-5xl mb-4">{service.icon}</div>
                <h3 className="text-2xl font-bold text-navy-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 mb-6">{service.description}</p>
                <ul className="space-y-2">
                  {service.features.map((feature, fIndex) => (
                    <li key={fIndex} className="flex items-center text-sm text-gray-700">
                      <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full mr-2"></span>
                      {feature}
                    </li>
                  ))}
                </ul>
                <Link to="/get-quote" className="block mt-6 w-full py-3 bg-navy-900 text-white font-bold rounded-lg hover:bg-navy-800 text-center">
                  Get Quote
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-br from-cyan-400 via-cyan-500 to-navy-900 text-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-black mb-6">
              What We Clean
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-12">
              {['Living Rooms', 'Bedrooms', 'Kitchens', 'Bathrooms', 'Dining Areas', 'Hallways', 'Stairs', 'Laundry Rooms'].map((room, index) => (
                <div key={index} className="bg-white/20 backdrop-blur-sm rounded-xl p-4 border border-white/30">
                  <p className="font-bold">{room}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-black text-navy-900 mb-6">
            Your Home, <span className="text-cyan-500">Our Priority</span>
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Experience the difference of professional residential cleaning
          </p>
          <Link to="/get-quote" className="inline-block px-12 py-5 bg-cyan-500 text-white font-black text-lg rounded-xl hover:bg-cyan-600 shadow-2xl">
            GET STARTED TODAY
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Residential;
